import { findImageUrls } from './htmlUtils';

export const parseInternalLink = (link) => {
    const hashIndex = link.url.indexOf('#');
    let taskOrModuleId = link.url;
    let hash = '';

    if (hashIndex > -1) {
        taskOrModuleId = link.url.substring(0, hashIndex);
        hash = `#${link.url.substring(hashIndex + 1)}`;
    }
    return { taskOrModuleId, hash };
};

export const getItemPositionInPatientProgram = (patientProgram, taskOrModuleId) => {
    let elementGroup;
    let elementIndex;
    let taskIndex;

    if (patientProgram) {
        const groups = Object.keys(patientProgram.groupedElements);
        for (let elementGroupIndex = 0; elementGroupIndex < groups.length; elementGroupIndex++) {
            const group = patientProgram.groupedElements[groups[elementGroupIndex]];
            for (elementIndex = 0; elementIndex < group.length; elementIndex++) {
                const el = group[elementIndex];
                elementGroup = el.elementGroup;
                if ((el.id === taskOrModuleId)
                    || (el.module && el.module.id === taskOrModuleId)
                    || (el.task && el.task.id === taskOrModuleId)) {
                    return { elementGroup, elementIndex, taskIndex };
                }
                if (el.module && el.module.tasks) {
                    for (taskIndex = 0; taskIndex < el.module.tasks.length; taskIndex++) {
                        const task = el.module.tasks[taskIndex];
                        if (task.id === taskOrModuleId) {
                            return { elementGroup, elementIndex, taskIndex };
                        }
                    }
                }
            }
        }
    }

    return { };
};

export const getItemFromPatientProgram = (patientProgram, elementId) => {
    if (patientProgram) {
        const groups = Object.keys(patientProgram.groupedElements);
        for (let elementGroupIndex = 0; elementGroupIndex < groups.length; elementGroupIndex++) {
            const group = patientProgram.groupedElements[groups[elementGroupIndex]];
            for (let elementIndex = 0; elementIndex < group.length; elementIndex++) {
                const el = group[elementIndex];
                if (el.id === elementId) return el;
                if (el.module && el.module.id === elementId) return el.module;
                if (el.task && el.task.id === elementId) return el.task;

                if (el.module && el.module.tasks) {
                    for (let taskIndex = 0; taskIndex < el.module.tasks.length; taskIndex++) {
                        if (el.module.tasks[taskIndex].id === elementId) {
                            return el.module.tasks[taskIndex];
                        }
                    }
                }
            }
        }
    }
    return null;
};

export const getItemPositionInProgram = (program, elementId) => {
    let moduleIndex;
    let taskIndex;

    if (program) {
        for (moduleIndex = 0; moduleIndex < program.modules.length; moduleIndex++) {
            const module = program.modules[moduleIndex];
            if (module.id === elementId) {
                return { moduleIndex, taskIndex };
            }
            if (module && module.tasks) {
                for (taskIndex = 0; taskIndex < module.tasks.length; taskIndex++) {
                    const task = module.tasks[taskIndex];
                    if (task.id === elementId) {
                        return { moduleIndex, taskIndex };
                    }
                }
            }
        }
    }
    return {};
};

export const getItemFromProgram = (program, elementId) => {
    if (program) {
        for (let moduleIndex = 0; moduleIndex < program.modules.length; moduleIndex++) {
            const module = program.modules[moduleIndex];
            if (module?.id === elementId) {
                return module;
            }
            for (let taskIndex = 0; taskIndex < module?.tasks?.length; taskIndex++) {
                const task = module.tasks[taskIndex];
                if (task?.id === elementId) {
                    return task;
                }
            }
        }
    }
    return null;
};

export const getImages = task => task.contentElements?.reduce((prev, curr) => [
    ...prev,
    ...findImageUrls(curr.htmlContent),
], []) || [];

export const preloadImagesInModule = module => module?.tasks?.map(t => getImages(t).map((id) => {
    const img = new Image();
    img.src = id;
    return id;
}));
